import { useEffect, useState } from "react";
import { loadStorefronts } from "@/components/StorefrontEditor";

/**
 * Subscribes to live storefront overrides (name + color for each of the 8
 * retail tenants). Updates whenever the user edits the StorefrontEditor.
 */
export function useStorefrontOverrides() {
  const [stores, setStores] = useState(loadStorefronts);

  useEffect(() => {
    const handler = (e) => setStores(e.detail || loadStorefronts());
    const storageHandler = () => setStores(loadStorefronts());
    window.addEventListener("storefronts-changed", handler);
    window.addEventListener("storage", storageHandler);
    return () => {
      window.removeEventListener("storefronts-changed", handler);
      window.removeEventListener("storage", storageHandler);
    };
  }, []);

  return stores;
}
